/* global grecaptcha */
import React, { useEffect, useState } from "react";
import "../style/DoctorContact.css";
import emailjs from "emailjs-com";

const DoctorContact = () => {
  const [formData, setFormData] = useState({
    name: "",
    number: "",
    email: "",
  });
  const [isDisabled, setIsDisabled] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleClick = (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    if (
      formData.name === "" ||
      formData.number === "" ||
      formData.email === ""
    ) {
      alert("Please fill in all required fields.");
      return;
    }
    handleSubmit(e);
    setIsDisabled(true);
    setFormData({
      name: "",
      number: "",
      email: "",
    });
    setTimeout(() => {
      setIsDisabled(false);
    }, 10000);
  };

  useEffect(() => {
    loadRecaptcha();
  }, []);

  const handleKeyDown = (event) => {
    if (
      event.key === "e" ||
      event.key === "E" ||
      event.key === "+" ||
      event.key === "-" ||
      event.key === "."
    ) {
      event.preventDefault();
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: name === "number" ? value.replace(/[^0-9]/g, "") : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(false);
    await loadRecaptcha();
    const token = await grecaptcha.enterprise.execute(
      "6Lcq_CsqAAAAAEko6Lgg1q8RWYhqiqXUtDrwJzD9",
      { action: "SUBMIT_FORM" }
    );

    if (!token) {
      alert("Failed to get reCAPTCHA token. Please try again.");
      return;
    }

    const templateParams = {
      name: formData.name,
      number: formData.number,
      email: formData.email,
      to_email: "lamaanaligners@gmail.com",
    };

    try {
      const response = await fetch(
        "https://recaptcha.healthflowonline.com/node/verify-recaptcha/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ token, recaptchaAction: "SUBMIT_FORM" }),
        }
      );

      const result = await response.json();
      if (result.success) {
        emailjs
          .send(
            "service_o9g42fl", // Replace with your EmailJS service ID
            "template_ki2qwda", // Replace with your EmailJS template ID
            templateParams,
            "kOdM1I8wHJsCHw4Dl" // Replace with your EmailJS user ID (public key)
          )
          .then(
            (response) => {
              console.log("SUCCESS!", response.status, response.text);
              alert("Form submitted successfully!");
            },
            (err) => {
              console.log("FAILED...", err);
              alert("Form submission failed. Please try again.");
            }
          );
      } else {
        alert("reCAPTCHA verification failed. Please try again.");
      }
    } catch (error) {
      console.error("Error verifying reCAPTCHA:", error);
      alert("Form submission failed. Please try again.");
    }
  };

  return (
    <div className="contact-container-alt" id="contact">
      <div className="form-container-alt">
        <h2 className="contact-title-alt">Reach Out</h2>
        <h2>Become a Partner Doctor</h2>
        <form
          className="contact-form-container-alt needs-validation"
          noValidate
        >
          <div className="form-group-alt">
            <input
              type="text"
              name="name"
              placeholder="Doctor Full Name *"
              required
              className={`input-placeholder ${
                isSubmitted && !formData.name ? "error" : ""
              }`}
              value={formData.name}
              onChange={handleChange}
            />
            {isSubmitted && !formData.name && (
              <div className="error-text">Required Field</div>
            )}
          </div>
          <div className="form-group-alt">
            <input
              type="number"
              name="number"
              placeholder="Mobile *"
              required
              className={`input-placeholder ${
                isSubmitted && !formData.number ? "error" : ""
              }`}
              value={formData.number}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
            />
            {isSubmitted && !formData.number && (
              <div className="error-text">Required Field</div>
            )}
          </div>
          <div className="form-group-alt">
            <div
              style={{
                width: "100%",
              }}
            >
              <input
                type="email"
                name="email"
                placeholder="Email"
                className={`input-placeholder`}
                value={formData.email}
                onChange={handleChange}
              />
            </div>
          </div>
          <button
            type="submit"
            className="contact-link-btn-alt"
            onClick={handleClick}
            disabled={isDisabled}
            style={{
              display: "flex",
              margin: "0 auto",
            }}
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default DoctorContact;

const loadRecaptcha = () => {
  return new Promise((resolve) => {
    if (document.getElementById("recaptcha-script")) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.id = "recaptcha-script";
    script.src =
      "https://www.google.com/recaptcha/enterprise.js?render=6Lcq_CsqAAAAAEko6Lgg1q8RWYhqiqXUtDrwJzD9";
    script.onload = resolve;
    document.body.appendChild(script);
  });
};
